import Vue from 'vue'
import Router from 'vue-router'
import AppNavBar from './components/AppNavbar.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: [
    {
      path: '/',
      name: 'home',
      components: {
        landing: () => import('./views/Home.vue')
      }
    },
    {
      path: '/login',
      name: 'login',
      components: {
        login: () => import('./views/Login.vue')
      } 
    },
    {
      path: '/request-reset-password',
      name: 'requestResetPassword',
      components: {
        login: () => import('./views/RequestResetPassword.vue')
      } 
    },
    {
      path: '/reset-password',
      name: 'resetPassword',
      components: {
        login: () => import('./views/ResetPassword.vue')
      } 
    },
    {
      path: '/user-profile',
      name: 'userProfile',
      components: {
        navbar: AppNavBar,
        content: () => import('./views/UserProfile.vue')
      } 
    },
    {
      path: '/mail-management',
      name: 'mailManagement',
      components: {
        navbar: AppNavBar,
        content: () => import('./views/MailManagement.vue')
      } 
    },
    {
      path: '/mail-management/detail',
      name: 'mailManagementDetail',
      components: {
        navbar: AppNavBar,
        content: () => import('./views/MailManagementDetail.vue')
      } 
    },
    {
      path: '/member-management',
      name: 'memberManagement',
      components: {
        navbar: AppNavBar,
        content: () => import('./views/MemberManagement.vue')
      } 
    },
    {
      path: '/member-management/detail',
      name: 'memberManagementDetail',
      components: {
        navbar: AppNavBar,
        content: () => import('./views/MemberManagementDetail.vue')
      } 
    },
    {
      path: '/submission-target',
      name: 'submissionTarget',
      components: {
        navbar: AppNavBar,
        content: () => import('./views/SubmissionTarget.vue')
      } 
    },
    {
      path: '/submission-target-detail',
      name: 'submissionTargetDetail',
      components: {
        navbar: AppNavBar,
        content: () => import('./views/SubmissionTargetDetail.vue')
      } 
    },
    {
      path: '/employee',
      name: 'employee',
      components: {
        navbar: AppNavBar,
        content: () => import('./views/Employee.vue')
      } 
    },
    {
      path: '/employee/detail',
      name: 'employeeDetail',
      components: {
        navbar: AppNavBar,
        content: () => import('./views/EmployeeDetail.vue')
      } 
    },
    {
      path: '/obs',
      name: 'observation',
      components: {
        content: () => import('./views/Observation.vue')
      } 
    },
    {
      path: '/observe-submitted',
      name: 'observeSubmitted',
      components: {
        content: () => import('./views/ObservationSubmitted.vue')
      } 
    },
    {
      path: '/action-submitted',
      name: 'actionSubmitted',
      components: {
        content: () => import('./views/ActionSubmitted.vue')
      } 
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      components: {
        navbar: AppNavBar,
        content: () => import('./views/Dashboard.vue')
      } 
    },
    {
      path: '/signup',
      name: 'signUp',
      components: {
        content: () => import('./views/SignUp.vue')
      } 
    },
    // App Transaction Route
    {
      path: '/qbo-admin',
      name: 'qboAdmin',
      components: {
        navbar: AppNavBar,
        content: () => import('./views/transaction/QBOAdmin.vue')
      } 
    },
    {
      path: '/qbo-admin-detail',
      name: 'qboAdminDetail',
      components: {
        navbar: AppNavBar,
        content: () => import('./views/transaction/QBOAdminDetail.vue')
      } 
    },
    {
      path: '/area-owner',
      name: 'areaOwner',
      components: {
        navbar: AppNavBar,
        content: () => import('./views/transaction/AreaOwner.vue')
      } 
    },
    {
      path: '/area-owner-detail',
      name: 'areaOwnerDetail',
      components: {
        navbar: AppNavBar,
        content: () => import('./views/transaction/AreaOwnerDetail.vue')
      } 
    },
    // App Report Route
    {
      path: '/report-cpar',
      name: 'reportCPAR',
      components: {
        navbar: AppNavBar,
        content: () => import('./views/report/ReportCPARPartial.vue')
      } 
    }
  ]
})
